import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'invites';
const REFERRALS = 'referrals';

export const INVITES_ENDPOINTS = {
  createInvite: () => formatEndpoint('', namespace),
  retrieveInvite: (inviteId: string) => formatEndpoint(inviteId, namespace),
  retrieveReferrals: () => formatEndpoint(REFERRALS, namespace),
};
